import { render, staticRenderFns } from "./resetSuccessCard.vue?vue&type=template&id=8971b172&scoped=true"
import script from "./resetSuccessCard.vue?vue&type=script&lang=js"
export * from "./resetSuccessCard.vue?vue&type=script&lang=js"
import style0 from "./resetSuccessCard.vue?vue&type=style&index=0&id=8971b172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8971b172",
  null
  
)

export default component.exports